/** Every call the app makes goes through here: same origin, the session cookie, §16's errors. */

export class AuthError extends Error {
  constructor() {
    super("Signed out");
    this.name = "AuthError";
  }
}

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly body: unknown,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function api<T>(path: string, init: { method?: string; body?: unknown; signal?: AbortSignal } = {}): Promise<T> {
  const response = await fetch(path, {
    method: init.method ?? "GET",
    credentials: "same-origin",
    headers: init.body === undefined ? { accept: "application/json" } : { accept: "application/json", "content-type": "application/json" },
    body: init.body === undefined ? undefined : JSON.stringify(init.body),
    signal: init.signal,
  });
  if (response.status === 401) throw new AuthError();
  const text = await response.text();
  const body: unknown = text ? safeJSON(text) : null;
  if (!response.ok) {
    const error = (body as { error?: { code?: string; message?: string } } | null)?.error;
    throw new ApiError(response.status, error?.code ?? "error", error?.message ?? "Something went wrong. Try again.", body);
  }
  return body as T;
}

function safeJSON(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

export interface Person {
  id: string;
  name: string;
  role: "athlete" | "coach";
  isAdmin: boolean;
  /** §17.2: may write and publish the week. */
  canPlan?: boolean;
}

export interface Me {
  person: Person;
  team: { name?: string; matesTraining?: boolean };
}
